// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__36YsP","ranges":"BmiRanges_ranges__1c_Qj"};